"use strict";
/**
 * Base class for component extensions.
 *
 * @packageDocumentation
 * @module BaseExtension
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Util Imports
var lodash_es_1 = require("lodash-es");
//#endregion
//#region Angular Imports
var angular_1 = tslib_1.__importDefault(require("angular"));
//#endregion
/**
 * Base class for component extensions that helps accessing angular injectables.
 */
var IMRBaseComponentExtension = /** @class */ (function () {
    function IMRBaseComponentExtension() {
        //#region Members
        this.serviceCache = {};
        //#endregion
    }
    //#endregion
    //#region Dependencies
    /**
     * Returns angular injectables with the given names.
     */
    IMRBaseComponentExtension.prototype.getServices = function (names) {
        var _this = this;
        return lodash_es_1.map(names, function (serviceName) {
            _this.getService(serviceName);
        });
    };
    /**
     * Returns angular injectable with the given name.
     */
    IMRBaseComponentExtension.prototype.getService = function (name) {
        var service = this.getServiceFromCache(name);
        if (service != null) {
            return service;
        }
        var $injector = this.getInjector();
        if ($injector.has(name)) {
            service = $injector.get(name);
            this.saveServiceInCache(name, service);
            return service;
        }
        return null;
    };
    IMRBaseComponentExtension.prototype.getInjector = function () {
        return angular_1.default.element('body').injector();
    };
    IMRBaseComponentExtension.prototype.getServiceFromCache = function (serviceName) {
        var _a;
        return (_a = this.serviceCache[serviceName]) !== null && _a !== void 0 ? _a : null;
    };
    IMRBaseComponentExtension.prototype.saveServiceInCache = function (serviceName, service) {
        this.serviceCache[serviceName] = service;
    };
    return IMRBaseComponentExtension;
}());
exports.IMRBaseComponentExtension = IMRBaseComponentExtension;
//# sourceMappingURL=base.extension.js.map